<template>
  <div>
    <b-card>
      <div>
        <div class="d-flex justify-content-between mb-1">
          <h3>معرض الصور</h3>
          <b-button
            variant="success"
            @click="onAddSlider()"
            v-can="{ slug: $route.meta.slug, action: 'C' }"
          >
            <feather-icon icon="PlusIcon" /> إضافة</b-button
          >
        </div>
        <hr />
        <data-table
          v-can="{ slug: $route.meta.slug, action: 'S' }"
          :fields="fields"
          ep="v2/slides"
          dataPath="data"
          ref="estatesTable"
        >
          <template #cell(actions)="row">
            <div class="d-flex justify-content-end">
              <b-button
                variant="flat-info"
                @click="row.toggleDetails"
                title="عرض المزيد من المعلومات"
                size="sm"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                class="btn-icon rounded-circle"
                v-b-tooltip.hover.v-info.top
              >
                <feather-icon icon="InfoIcon" size="1.8x" color="#4fc98c" />
              </b-button>
              <b-button
                size="sm"
                @click="onDeleteClicked(row.item.id)"
                variant="flat-danger"
                class="btn-icon rounded-circle"
                v-can="{ slug: $route.meta.slug, action: 'D' }"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <b-button
                size="sm"
                @click="onEditClicked(row.item)"
                variant="flat-info"
                class="btn-icon rounded-circle"
                v-can="{ slug: $route.meta.slug, action: 'U' }"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </div>
          </template>
          <template #row-details="row">
            <b-card>
              <b-row>
                <b-col cols="4">
                  <b-img
                    :src="row.item.source"
                    height="60px"
                    class="w-100 h-100"
                  />
                </b-col>
                <b-col>
                  <h4>التفاصيل</h4>
                  <hr />
                  <p class="mx-1">
                    {{ row.item.description }}
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </data-table>
      </div>

      <form-modal
        ref="estateModal"
        :formSchema="estatesFormSchema"
        v-model="activModel"
        :loading="loading"
        @confirm="onModalConfirmed"
      >
        <template #source="{ form }">
          <form-file
            label="الصورة"
            accept="image/*"
            id="form-slider-image"
            placeholder="اختر صورة"
            name="image"
            @change="previewImage"
          />
          <div class="border rounded-lg text-center mb-1">
            <img
              v-if="localImage"
              :src="localImage"
              class="img-fluid rounded-lg"
              id="preview"
            />
            <feather-icon v-else icon="ImageIcon" class="my-3" size="30" />
          </div>
        </template>
        <template #link_checkbox>
          <b-form-checkbox class="my-1" v-model="withLink"
            >إضافة رابط</b-form-checkbox
          >
        </template>
        <template #link_title="{ form }">
          <form-input
            v-show="withLink"
            label="نص الرابط"
            :rules="withLink ? 'required' : ''"
            v-model="form.link_title"
          />
        </template>
        <template #link_url="{ form }">
          <form-input
            v-show="withLink"
            dir="ltr"
            label="الرابط التشعبي (URL)"
            :rules="withLink ? 'required|url' : ''"
            v-model="form.link_url"
          />
        </template>
      </form-modal>
    </b-card>
  </div>
</template>
<script>
import CardSlide from "../../components/CardSlide.vue";
import AddSliderDialog from "../../components/AddSliderDialog.vue";
import {
  BCard,
  BButton,
  BFormCheckbox,
  VBTooltip,
  BRow,
  BCol,
  BImg,
} from "bootstrap-vue";
import DataTable from "@/components/data-table";
import FormModal from "@/components/FormModal.vue";
import Ripple from "vue-ripple-directive";
import FormFile from "@/components/form-file/index.vue";
import FormInput from "@/components/form-input/index.vue";

import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    CardSlide,
    BCard,
    BButton,
    BFormCheckbox,
    AddSliderDialog,
    FormModal,
    DataTable,
    VBTooltip,
    BRow,
    BCol,
    BImg,
    FormFile,
    FormInput,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      image: null,
      localImage: null,
      activModel: false,
      withLink: false,
      fields: [
        {
          key: "title",
          label: "العنوان",
        },
        {
          key: "actions",
          label: "",
        },
      ],

      estatesFormSchema: {
        source: {
          key: "source",
        },
        title: {
          component: "FormInput",
          key: "title",
          attrs: {
            label: "العنوان",
            rules: "required",
          },
        },
        description: {
          component: "FormTextarea",
          key: "description",
          attrs: {
            label: "التفاصيل",
            rules: "required",
          },
        },

        link_checkbox: { key: "link_checkbox" },
        link_title: { key: "link_title" },
        link_url: { key: "link_url" },
      },
    };
  },
  methods: {
    ...mapActions("manageInterfaceNgo/ngoSlider", [
      "editSlide",
      "createSlider",
      "deleteSlide",
    ]),
    onAddSlider() {
      this.activModel = true;
      this.$refs.estateModal.init({});
      this.image = null;
      this.localImage = null;
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف ؟", {
          title: "تأكيد حذف ",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.deleteSlide(id).then(() => {
              this.$refs.estatesTable.refreshTable();
            });
          }
        });
    },

    onEditClicked(form) {
      this.$refs.estateModal.init({
        id: form.id,
        title: form.title,
        description: form.description,
        source: this.image,
      });
      this.localImage = form.source;
      this.activModel = true;
    },

    previewImage(event) {
      this.image = event.target.files[0];
      this.localImage = URL.createObjectURL(this.image);
    },

    onModalConfirmed(form) {
      var request = new FormData();
      request.append("title", form.title);
      request.append("description", form.description);
      request.append("source", this.image);
      if (this.withLink) {
        request.append("link_title", form.link_title);
        request.append("link_url", form.link_url);
      }

      if (form.id) {
        request.append("id", form.id);
        request.append("_method", "PUT");
        this.editSlide({
          id: form.id,
          fd: request,
        }).then(() => {
          this.activModel = false;
          this.$refs.estatesTable.refreshTable();
        });
      } else
        this.createSlider({
          fd: request,
        }).then(() => {
          this.activModel = false;
          this.$refs.estatesTable.refreshTable();
        });
    },
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/ngoSlider", ["loading"]),
  },
};
</script>
